export default function (tag) {
  return tag.replace(/_/g, ' ')
}



// WEBPACK FOOTER //
// ./src/utils/clean-tag.js